__turbopack_context__.v({
  "container": "Avatar-module-scss-module__5yp2FG__container",
  "image": "Avatar-module-scss-module__5yp2FG__image",
  "initials": "Avatar-module-scss-module__5yp2FG__initials",
  "small": "Avatar-module-scss-module__5yp2FG__small",
  "tiny": "Avatar-module-scss-module__5yp2FG__tiny",
});
